import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { PlanoOrganizacao, RecursoPlano } from '@/lib/planos';

type PlanoOrganizacaoInfo = {
  plano: PlanoOrganizacao;
  maxFiliais: number;
  maxUsuarios: number;
  recursos: Record<RecursoPlano, boolean>;
};

const RECURSOS_DESLIGADOS: Record<RecursoPlano, boolean> = {
  transferenciaFiliais: false,
  relatorioConsolidado: false,
  painelRede: false,
};

/**
 * Quick 260820-dqz — lê `GET /v1/organizacao/plano` do tenant. `staleTime`
 * de um minuto para a troca de plano feita pelo superadmin aparecer rápido
 * no cliente, sem exigir novo login. Enquanto carrega OU em erro de rede, os
 * três recursos são tratados como desligados — nunca mostrar e depois
 * esconder, coerente com o backend fail-closed.
 */
export function useRecursosPlano() {
  const { data, isLoading } = useQuery({
    queryKey: ['organizacao', 'plano'],
    queryFn: async () => {
      const { data } = await api.get<PlanoOrganizacaoInfo>('/organizacao/plano');
      return data;
    },
    staleTime: 60_000,
    retry: 1,
  });

  return {
    plano: data?.plano ?? 'BALCAO',
    maxFiliais: data?.maxFiliais ?? 1,
    maxUsuarios: data?.maxUsuarios ?? 5,
    recursos: isLoading || !data ? RECURSOS_DESLIGADOS : data.recursos,
    isLoading,
  };
}
